import { render } from "./Modal.htm?vue&type=template&id=3f280bb2"
import script from "./Modal.js?vue&type=script&lang=js"
export * from "./Modal.js?vue&type=script&lang=js"

import "./Modal.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__